import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import toDollars from 'utils/to-dollars';

// Selectors
import { AppState } from 'services/types';
import { EntityId } from 'services/entities/types';
import { TimesheetHolidayDate } from 'services/timesheetHolidays/types';
import TimesheetHolidayGate from 'components/TimesheetHolidayGate';
import { TIMESHEET_HOLIDAYS_MULTIPLIER } from 'services/timesheetHolidays/constants';
import { makeSelectTimesheetEntryValue } from '../../../../../../../../../../services/timesheetEntries/selectors';

interface OwnProps {
    timesheetEntryUuid: string;
}

interface ConnectedProps {
    effectiveRate?: number;
    entityId: EntityId;
    date: TimesheetHolidayDate;
}

type Props = OwnProps & ConnectedProps;

export class TimesheetEntryEffectiveRateComponent extends React.PureComponent<Props> {
    render(): React.ReactElement | null {
        const { effectiveRate, date, entityId } = this.props;
        if (!effectiveRate) return null;

        return (
            <TimesheetHolidayGate
                fallback={toDollars(effectiveRate)}
                timesheetDate={date}
                timesheetEntityId={entityId}
            >
                {toDollars(effectiveRate * TIMESHEET_HOLIDAYS_MULTIPLIER)}
            </TimesheetHolidayGate>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    effectiveRate: makeSelectTimesheetEntryValue('effectiveRate'),
    entityId: makeSelectTimesheetEntryValue('entityId'),
    date: makeSelectTimesheetEntryValue('date')
});

export default connect(mapStateToProps)(TimesheetEntryEffectiveRateComponent);
